<ng-container [ngSwitch]="subjectsListConfiguration.type">
  <gen-dynamic-form *ngSwitchCase="'form'"
                    [formName]="formId"
                    [formItemFullWidth]="subjectsListConfiguration.formConf?.formItemFullWidth"
                    [additionalSearchValues]="additionalSearchValues$ | async"
                    [listenToDataChange]="true"
                    [formData]="{ resources: resourcesMap$ | async}"
                    (formChange)="processSubject($event)"
  ></gen-dynamic-form>
  <gen-treatment-subject *ngSwitchDefault
                         [reflexMessage]="reflexMessage"
                         [isEditable]="isEditable"
                         [showInReportToggleActive]="showInReportToggleActive"
                         [showInMIToggleActive]="showInMIToggleActive"
                         [subjectsListConfiguration]="subjectsListConfiguration"
                         (onSubjectIdentifierChange)="processSubject($event)"
                         (onchangeOpinionOfMI)="onchangeOpinionOfMI.emit($event)"
  ></gen-treatment-subject>
</ng-container>

